import { filterAllValores, getAllValores, saveValor, updateValor } from '@/services/api/valor.js';
export const actions = {
  async getValoresByFilter(state, filter) {
    try {
      const dataList = await filterAllValores(filter);
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getAllValores(state) {
    try {
      const dataList = await getAllValores();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveValor(state, payload) {
    try {
      await saveValor(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateValor(state, payload) {
    try {
      await updateValor(payload);
    } catch (error) {
        /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  }
}
